// extracted by mini-css-extract-plugin
export var widgetInline = "widget-module--widget-inline--cnSdZ";